import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { useCartAlerts } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/hooks/useCartAlerts';
import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const ArticleTypeAlert = () => {
  const { needsRequiredArticle, missingTypes, hasService, hasAuto } = useCartAlerts();

  return (
    <CustomCartAlert icon={missingTypes?.length === 1 ? ArticleTypeMap.toIcon(missingTypes[0]) : 'info'}>
      {needsRequiredArticle && <MissingTypesList missingTypes={missingTypes} />}
      {hasService && <ServiceNote />}
      {hasAuto && <AutoNote />}
    </CustomCartAlert>
  );
};

const MissingTypesList = ({ missingTypes }) => {
  const { getTextIdTranslation } = useTranslation();

  return (
    <span>
      {getTextIdTranslation('CART_ALERT_ARTICLE_TYPE_START')}{' '}
      {missingTypes.map((type, i, arr) => {
        return (
          <span key={i}>
            <strong>{getTextIdTranslation(type).toLowerCase()}</strong>
            {i < arr.length - 2 ? ', ' : i < arr.length - 1 ? ` ${getTextIdTranslation('OR')} ` : '.'}{' '}
          </span>
        );
      })}
    </span>
  );
};

const ServiceNote = () => {
  const { getTextIdTranslation } = useTranslation();

  return <span>{getTextIdTranslation('CART_ALERT_ARTICLE_TYPE_SERVICE_ADDITIONAL')} </span>;
};

const AutoNote = () => {
  const { getTextIdTranslation } = useTranslation();

  return <span>{getTextIdTranslation('CART_ALERT_ARTICLE_TYPE_AUTO_ADDITIONAL')} </span>;
};
